/**
 * CIDR 클라이언트 보조 검증(최종 판정은 서버).
 * IPv4 단일/CIDR, IPv6는 기본 형태만 허용.
 */
const IPV4_OCTET = '(25[0-5]|2[0-4]\\d|1\\d{2}|[1-9]?\\d)';
const IPV4_ADDR = `${IPV4_OCTET}(\\.${IPV4_OCTET}){3}`;
const IPV4_CIDR = new RegExp(
  `^${IPV4_ADDR}(/(3[0-2]|[12]?\\d))?$`
);

/** 매우 단순한 IPv6 허용(완전 검증은 서버) */
function looksLikeIpv6Cidr(s: string): boolean {
  const slash = s.lastIndexOf('/');
  let addr = s;
  if (slash !== -1) {
    const pref = parseInt(s.slice(slash + 1), 10);
    if (Number.isNaN(pref) || pref < 0 || pref > 128) {
      return false;
    }
    addr = s.slice(0, slash);
  }
  return addr.length > 0 && /^[0-9a-fA-F:.]+$/.test(addr);
}

export function validateCidrClientInput(raw: string): string | null {
  const s = (raw || '').trim();
  if (!s) {
    return 'CIDR 또는 IP 주소를 입력해주세요.';
  }
  if (s.length > 64) {
    return '입력은 64자 이하여야 합니다.';
  }
  if (/\s/.test(s)) {
    return '공백은 사용할 수 없습니다.';
  }
  if (s.includes(':')) {
    if (!looksLikeIpv6Cidr(s)) {
      return 'IPv6 형식이 올바르지 않습니다. 예: 2001:db8::1 또는 2001:db8::/32';
    }
    return null;
  }
  if (!IPV4_CIDR.test(s)) {
    return 'IPv4 형식이 올바르지 않습니다. 예: 203.0.113.10 또는 203.0.113.0/24';
  }
  return null;
}
